import { Controller } from "@hotwired/stimulus"

// The reader's full-coverage drawer: a modal <dialog> holding the `story-coverage` Turbo Frame.
// Coverage links target that frame, so Turbo fetches the coverage page into it; `open` shows the
// drawer straight away with a loading line so the click is answered at once. Without JavaScript
// the same links open the coverage page itself.
// Connects to data-controller="coverage-drawer"
export default class extends Controller {
    static targets = ["dialog", "frame"]

    disconnect() {
        if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
    }

    open(event) {
        if (!this.hasDialogTarget || !this.hasFrameTarget || typeof this.dialogTarget.showModal !== "function") return

        this.opener = event.currentTarget
        this.frameTarget.replaceChildren(this.loadingElement())
        if (!this.dialogTarget.open) this.dialogTarget.showModal()
        document.body.classList.add("nfr-reader-sheet-open")
    }

    close(event) {
        if (!this.hasDialogTarget || !this.dialogTarget.open) return

        event?.preventDefault()
        this.dialogTarget.close()
    }

    // A click on the dimmed backdrop lands on the <dialog> itself.
    backdropClose(event) {
        if (event.target === this.dialogTarget) this.close()
    }

    loaded() {
        this.frameTarget.querySelector("#story-coverage-title")?.focus({ preventScroll: true })
    }

    closed() {
        document.body.classList.remove("nfr-reader-sheet-open")
        this.frameTarget.removeAttribute("src")
        this.frameTarget.replaceChildren()
        this.opener?.focus({ preventScroll: true })
        this.opener = null
    }

    loadingElement() {
        const element = document.createElement("div")
        element.className = "nfr-reader-loading nfr-coverage-loading"
        element.innerHTML = '<span class="nfr-reader-spinner" role="status" aria-hidden="true"></span><span>Loading every version…</span>'
        return element
    }
}
